import { ApiUrl } from '@common/enums';
import { PlumbingProduct } from '@common/models';
import { easyEstimatorApi } from '@ee-api/easyEstimatorService';
import { CommonProductQueryParams } from '@ee-api/queryParams';

const plumbingService = easyEstimatorApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchPlumbing: builder.query<PlumbingProduct[], CommonProductQueryParams>({
            query: ({ params }) => ({
                url: ApiUrl.PLUMBING,
                method: 'GET',
                params,
            }),
        }),
    }),
});

export const { useFetchPlumbingQuery, useLazyFetchPlumbingQuery } = plumbingService;
